import { Box } from '@mui/material';
import { useModal } from '../../../context/ModalProvider/useModal';
import { CreateManager } from './CreateManager';
import TrashIcon from '../../../assets/Icons/trash';
import { UserService } from '../../../Service/UserService';
import { useAppDispatch } from '../../../store/hooks';
import { createNotification } from '../../../store/notifications/notification-slice';
import { User } from '../../../Utilis/Types/User';
import { Meta } from '../../../Utilis/Types/Generic';

type Props = {
  setMeta: React.Dispatch<React.SetStateAction<Meta | undefined>>;
  setUsers: React.Dispatch<React.SetStateAction<User[]>>;
};

export const useManagerModals = ({ setMeta, setUsers }: Props) => {
  const { openModal, closeModal } = useModal();
  const appDispatch = useAppDispatch();

  const onSubmit = async (data: any) => {
    try {
      const response: any = await UserService.createMember(data.email);

      setUsers(prevUsers => [...prevUsers, response.data]);

      setMeta(prevMeta => ({
        ...prevMeta!,
        itemCount: prevMeta!.itemCount! + 1,
      }));
      closeModal();
    } catch (error: any) {
      appDispatch(
        createNotification({
          type: 'error',
          message: error.message,
        })
      );
    }
  };

  const removeMember = async (userId: string) => {
    try {
      await UserService.removeMember(userId);

      setUsers(prevUsers => {
        return prevUsers.filter(user => user.id !== userId);
      });

      setMeta(prevMeta => ({
        ...prevMeta!,
        itemCount: prevMeta!.itemCount! - 1,
      }));
      closeModal();
    } catch (error) {
      appDispatch(
        createNotification({
          type: 'error',
          message: 'Something went wrong! Please try again later.',
        })
      );
    }
  };

  const openCreateManagerModal = () => {
    openModal({
      title: 'Add a new Member',
      body: <CreateManager onSubmit={onSubmit} />,
      hideFooter: true,
    });
  };

  const openRemoveManagerModal = async (data: any) => {
    openModal({
      icon: (
        <Box
          sx={{
            background: '#FEF3F2',
            width: '48px',
            height: '48px',
            borderRadius: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '7px',
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: '100%',
              background: '#FEE4E2',
              borderRadius: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <TrashIcon size={24} color='#D92D20' />
          </Box>
        </Box>
      ),
      title: 'Delete Member',
      description:
        'Are you sure you want to delete this member? This action cannot be undone.',
      onSubmit: () => removeMember(data.id),
    });
  };

  return { openCreateManagerModal, openRemoveManagerModal };
};
